import React from 'react'

interface FlightDetailsArrivalProps {
    isTripEnd: boolean
    isFirst: boolean
}

const FlightDetailsArrival = ({ isTripEnd, isFirst }: FlightDetailsArrivalProps) => {
    return (
        <svg width="11" height="76" viewBox="0 0 11 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2086_100734)">
                <rect x="5" y="33" width="33" height="1" transform="rotate(-90 5 33)" fill="#B3B3B3" />
            </g>
            {isTripEnd ? (
                <circle cx="5.5" cy="38.5" r="5.5" fill="#B3B3B3" />
            ) : (
                <circle cx="5.5" cy="37.5" r="4.5" fill="white" stroke="#B3B3B3" stroke-width="2" />
            )}
            {isFirst && <path d="M5.5 42L5.5 75" stroke="#B3B3B3" stroke-linecap="round" stroke-dasharray="2 3" />}
            <defs>
                <clipPath id="clip0_2086_100734">
                    <rect x="5" y="33" width="33" height="1" rx="0.5" transform="rotate(-90 5 33)" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FlightDetailsArrival
